<template>
	<div>
		<div class="content">
			<div class="container help-center">
				<leftAbout></leftAbout>
				<div class="help-main">
					<h2>平台公告</h2>
					<div class="timeline notice-timeline">
            <s class="timeline-line"></s>
						<ul class="timeline-listing">
							<li class="timeline-item" v-for="(item,index) in noticleList" :key="index">
                <div class="timeline-date">
                  <i class="dot"></i>
                  {{item.view_time.split('-')[1]}}
                  <span>{{item.view_time.split('-')[1]+'-'+item.view_time.split('-').pop()}}</span>
                </div>
								<div class="timeline-main">
                  <h5>{{item.article_title}}</h5>
                  <p v-html="HTMLDecode(item.article_content)"></p>
								</div>
							</li>
						</ul>
            <div class="text-right">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="current_page"
                :page-size="per_page"
                layout="prev, pager, next, jumper,total"
                :page-count='last_page'
                :total="total">
              </el-pagination>
            </div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import leftAbout from '../common/about/index.vue'
	export default{
		name:"Notice",
		data(){
			return{
				noticle:"",
        noticleList:[],
        current_page:1,
        per_page:15,
        last_page:1,
        total:15
			}
		},
		created(){
			this.getNotcile()
		},
		components:{
			leftAbout
		},
		methods:{
      handleCurrentChange(val) {
      	this.current_page = val
      	this.getNotcile()
      },
      HTMLDecode(text) {
      	var temp = document.createElement("div");
      	temp.innerHTML = text;
      	var output = temp.innerText || temp.textContent;
      	temp = null;
      	return output;
      },
			getNotcile(){
				let token = localStorage.getItem('token')
				this.$api.noticepc({
					token:token,
          page:this.current_page
				}).then(res => {
          // console.log(res)
					if(res.code === 1){
            this.current_page = res.data.current_page
            this.last_page = res.data.last_page
            this.per_page = res.data.per_page
            this.total = res.data.total
            this.noticleList = res.data.data
					}
				})
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/about/notice.vue